/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class BomMaterialServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 关联子物料
     * @param bomMaterialAddDTO bomMaterialAddDTO
     * @return OK
     */
    createBomMaterial(bomMaterialAddDTO: BomMaterialAddDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-material";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bomMaterialAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateBomMaterial(_response);
        });
    }

    protected processCreateBomMaterial(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 查询bom物料菜单信息
     * @param productCode productCode
     * @param versionId versionId
     * @return OK
     */
    materialList(productCode: string, versionId: string): Promise<BomMaterialSimpleVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-material/list?";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined and cannot be null.");
        else
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&"; 
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined and cannot be null.");
        else
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMaterialList(_response);
        });
    }

    protected processMaterialList(response: AxiosResponse): Promise<BomMaterialSimpleVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BomMaterialSimpleVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<BomMaterialSimpleVO[]>(<any>null);
    }

    /**
     * 关联子物料
     * @param bomMaterialAddPostDTO bomMaterialAddPostDTO
     * @return OK
     */
    createBomMaterialForOpenApi(bomMaterialAddPostDTO: BomMaterialAddPostDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-material/open-api";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bomMaterialAddPostDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateBomMaterialForOpenApi(_response);
        });
    }

    protected processCreateBomMaterialForOpenApi(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * bom物料以及工序详情
     * @param id id
     * @return OK
     */
    materialDetail(id: string): Promise<BomMaterialVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-material/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMaterialDetail(_response);
        });
    }

    protected processMaterialDetail(response: AxiosResponse): Promise<BomMaterialVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? BomMaterialVO.fromJS(resultData200) : new BomMaterialVO();
            return result200;
        }
        return Promise.resolve<BomMaterialVO>(<any>null);
    }

    /**
     * 删除物料
     * @param id id
     * @return OK
     */
    deleteBomMaterial(id: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-material/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteBomMaterial(_response);
        });
    }

    protected processDeleteBomMaterial(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class BomProcessServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除物料工序
     * @param id id
     * @return OK
     */
    deleteBomProcess(id: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-process";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteBomProcess(_response);
        });
    }

    protected processDeleteBomProcess(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class BomVersionServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增bom版本
     * @param bomVersionAddDTO bomVersionAddDTO
     * @return OK
     */
    createBomMaterial(bomVersionAddDTO: BomVersionAddDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-version";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bomVersionAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateBomMaterial(_response);
        });
    }

    protected processCreateBomMaterial(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 根据产品ID或工艺版本ID或主键ID获取产品Bom版本列表
     * @param bomVersionId (optional) bom版本主键id
     * @param craftId (optional) 工艺版本id
     * @param productId (optional) 产品id
     * @return OK
     */
    getBomVersionByProductAndCraft(bomVersionId: string | null | undefined, craftId: string | null | undefined, productId: string | null | undefined): Promise<BomVersionVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-version/craft/list?";
        if (bomVersionId !== undefined)
            url_ += "bomVersionId=" + encodeURIComponent("" + bomVersionId) + "&"; 
        if (craftId !== undefined)
            url_ += "craftId=" + encodeURIComponent("" + craftId) + "&"; 
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetBomVersionByProductAndCraft(_response);
        });
    }

    protected processGetBomVersionByProductAndCraft(response: AxiosResponse): Promise<BomVersionVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BomVersionVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<BomVersionVO[]>(<any>null);
    }

    /**
     * 定版Bom版本
     * @param id id
     * @return OK
     */
    fixedEditionForBom(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-version/fixedEdition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFixedEditionForBom(_response);
        });
    }

    protected processFixedEditionForBom(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * open-api新增bom版本
     * @param bomVersionApiAddDTO bomVersionApiAddDTO
     * @return OK
     */
    createBomMaterialForOpenApi(bomVersionApiAddDTO: BomVersionApiAddDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-version/open-api";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bomVersionApiAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateBomMaterialForOpenApi(_response);
        });
    }

    protected processCreateBomMaterialForOpenApi(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 查看工艺版本备注
     * @param versionId versionId
     * @return OK
     */
    getRemarkInfo(versionId: string): Promise<BomVersionRemarkVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-version/remark/{versionId}";
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRemarkInfo(_response);
        });
    }

    protected processGetRemarkInfo(response: AxiosResponse): Promise<BomVersionRemarkVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? BomVersionRemarkVO.fromJS(resultData200) : new BomVersionRemarkVO();
            return result200;
        }
        return Promise.resolve<BomVersionRemarkVO>(<any>null);
    }

    /**
     * 保存bom版本备注
     * @param saveRemarkDTO saveRemarkDTO
     * @return OK
     */
    saveBomRemark(saveRemarkDTO: SaveRemarkDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-version/save-remark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveRemarkDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveBomRemark(_response);
        });
    }

    protected processSaveBomRemark(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 根据工艺版本Id查询bom版本
     * @param craftId craftId
     * @return OK
     */
    getBomVersionByCraftId(craftId: string): Promise<BomCraftVersionVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-version/{craftId}/bom-list";
        if (craftId === undefined || craftId === null)
            throw new Error("The parameter 'craftId' must be defined.");
        url_ = url_.replace("{craftId}", encodeURIComponent("" + craftId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetBomVersionByCraftId(_response);
        });
    }

    protected processGetBomVersionByCraftId(response: AxiosResponse): Promise<BomCraftVersionVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BomCraftVersionVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<BomCraftVersionVO[]>(<any>null);
    }

    /**
     * 删除bom版本
     * @param id id
     * @return OK
     */
    deleteBomVersion(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-version/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteBomVersion(_response);
        });
    }

    protected processDeleteBomVersion(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 根据产品ID获取产品Bom版本列表
     * @param productId productId
     * @return OK
     */
    getBomVersionByProduct(productId: string): Promise<BomVersionVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/bom-version/{productId}/list";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetBomVersionByProduct(_response);
        });
    }

    protected processGetBomVersionByProduct(response: AxiosResponse): Promise<BomVersionVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BomVersionVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<BomVersionVO[]>(<any>null);
    }
}

export class MaterialFieldSettingServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询物料字段设置
     * @return OK
     */
    get(): Promise<MaterialFieldSettingVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material-field-setting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<MaterialFieldSettingVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialFieldSettingVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaterialFieldSettingVO[]>(<any>null);
    }

    /**
     * 保存物料字段设置
     * @param materialFieldSettingDTOList materialFieldSettingDTOList
     * @return OK
     */
    save(materialFieldSettingDTOList: MaterialFieldSettingDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material-field-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(materialFieldSettingDTOList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class MaterialTypeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增物料类型
     * @param materialTypeAddDTO materialTypeAddDTO
     * @return OK
     */
    createMaterialType(materialTypeAddDTO: MaterialTypeAddDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material-type/create-material-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(materialTypeAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateMaterialType(_response);
        });
    }

    protected processCreateMaterialType(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 删除物料类型（支持批量）
     * @param ids ids
     * @return OK
     */
    deleteMaterialType(ids: string[]): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material-type/delete-material-type?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteMaterialType(_response);
        });
    }

    protected processDeleteMaterialType(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 查询物料类型
     * @param id id
     * @return OK
     */
    getMaterialType(id: string): Promise<MaterialTypeVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material-type/get-material-type?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMaterialType(_response);
        });
    }

    protected processGetMaterialType(response: AxiosResponse): Promise<MaterialTypeVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MaterialTypeVo.fromJS(resultData200) : new MaterialTypeVo();
            return result200;
        }
        return Promise.resolve<MaterialTypeVo>(<any>null);
    }

    /**
     * 查询物料类型列表（不分页）
     * @return OK
     */
    getMaterialTypeList(): Promise<MaterialTypeVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material-type/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMaterialTypeList(_response);
        });
    }

    protected processGetMaterialTypeList(response: AxiosResponse): Promise<MaterialTypeVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialTypeVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaterialTypeVo[]>(<any>null);
    }

    /**
     * 查询分页
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageMaterialType(current: number | null | undefined, size: number | null | undefined): Promise<IPageOfMaterialTypeVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material-type/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageMaterialType(_response);
        });
    }

    protected processGetPageMaterialType(response: AxiosResponse): Promise<IPageOfMaterialTypeVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMaterialTypeVo.fromJS(resultData200) : new IPageOfMaterialTypeVo();
            return result200;
        }
        return Promise.resolve<IPageOfMaterialTypeVo>(<any>null);
    }

    /**
     * 修改物料类型
     * @param materialTypeUpdateDTO materialTypeUpdateDTO
     * @return OK
     */
    updateMaterialType(materialTypeUpdateDTO: MaterialTypeUpdateDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material-type/update-material-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(materialTypeUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateMaterialType(_response);
        });
    }

    protected processUpdateMaterialType(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class MaterialServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增物料
     * @param materialAddDTO materialAddDTO
     * @return OK
     */
    createMaterial(materialAddDTO: MaterialAddDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/create-material";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(materialAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateMaterial(_response);
        });
    }

    protected processCreateMaterial(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除物料（支持批量）
     * @param ids ids
     * @return OK
     */
    deleteMaterial(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/delete-material?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteMaterial(_response);
        });
    }

    protected processDeleteMaterial(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 导出物料数据
     * @param materialExportDTO materialExportDTO
     * @return OK
     */
    exportProduct(materialExportDTO: MaterialExportDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(materialExportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProduct(_response);
        });
    }

    protected processExportProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出物料模板
     * @return OK
     */
    exportMaterialTemplate(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/export/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportMaterialTemplate(_response);
        });
    }

    protected processExportMaterialTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询物料
     * @param id id
     * @return OK
     */
    getMaterial(id: string): Promise<MaterialVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/get-material?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMaterial(_response);
        });
    }

    protected processGetMaterial(response: AxiosResponse): Promise<MaterialVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MaterialVo.fromJS(resultData200) : new MaterialVo();
            return result200;
        }
        return Promise.resolve<MaterialVo>(<any>null);
    }

    /**
     * 根据物料code集合查询物料详情
     * @param codes 物料codes
     * @return OK
     */
    getMaterialByCode(codes: string[]): Promise<MaterialVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/get-material-by-codes?";
        if (codes === undefined || codes === null)
            throw new Error("The parameter 'codes' must be defined and cannot be null.");
        else
            codes && codes.forEach(item => { url_ += "codes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMaterialByCode(_response);
        });
    }

    protected processGetMaterialByCode(response: AxiosResponse): Promise<MaterialVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaterialVo[]>(<any>null);
    }

    /**
     * 导入物料数据
     * @param file (optional) file
     * @return OK
     */
    importMaterial(file: FileParameter | null | undefined): Promise<MaterialExportResult> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportMaterial(_response);
        });
    }

    protected processImportMaterial(response: AxiosResponse): Promise<MaterialExportResult> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? MaterialExportResult.fromJS(resultData200) : new MaterialExportResult();
            return result200;
        }
        return Promise.resolve<MaterialExportResult>(<any>null);
    }

    /**
     * 导入物料数据
     * @param file (optional) file
     * @return OK
     */
    importMaterialVerification(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/import-verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportMaterialVerification(_response);
        });
    }

    protected processImportMaterialVerification(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询物料列表（不分页）
     * @param isFinishedProduct (optional) 是否是成品(1:成品;2非成品)
     * @param keyWord (optional) 关键词
     * @param property (optional) 物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它
     * @param typeId (optional) 物料类型ID
     * @return OK
     */
    getMaterialList(isFinishedProduct: number | null | undefined, keyWord: string | null | undefined, property: number | null | undefined, typeId: string | null | undefined): Promise<MaterialVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/list?";
        if (isFinishedProduct !== undefined)
            url_ += "isFinishedProduct=" + encodeURIComponent("" + isFinishedProduct) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        if (property !== undefined)
            url_ += "property=" + encodeURIComponent("" + property) + "&"; 
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMaterialList(_response);
        });
    }

    protected processGetMaterialList(response: AxiosResponse): Promise<MaterialVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaterialVo[]>(<any>null);
    }

    /**
     * 通过物料Id查询物料列表
     * @param idList idList
     * @return OK
     */
    getMaterialListByIds(idList: string[]): Promise<MaterialVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/list-by-ids?";
        if (idList === undefined || idList === null)
            throw new Error("The parameter 'idList' must be defined and cannot be null.");
        else
            idList && idList.forEach(item => { url_ += "idList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMaterialListByIds(_response);
        });
    }

    protected processGetMaterialListByIds(response: AxiosResponse): Promise<MaterialVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaterialVo[]>(<any>null);
    }

    /**
     * 可以关联的物料列表
     * @param areaId areaId(库区ID)
     * @param locationId locationId(库位ID)
     * @return OK
     */
    getMaterialListCanRelate(areaId: string, locationId: string): Promise<MaterialVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/list-can-releta?";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined and cannot be null.");
        else
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined and cannot be null.");
        else
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMaterialListCanRelate(_response);
        });
    }

    protected processGetMaterialListCanRelate(response: AxiosResponse): Promise<MaterialVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaterialVo[]>(<any>null);
    }

    /**
     * 根据barCode查询物料列表（不分页）
     * @param barCode (optional) 物料条码
     * @return OK
     */
    getMaterialListMobile(barCode: string | null | undefined): Promise<MaterialVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/mobile/list?";
        if (barCode !== undefined)
            url_ += "barCode=" + encodeURIComponent("" + barCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMaterialListMobile(_response);
        });
    }

    protected processGetMaterialListMobile(response: AxiosResponse): Promise<MaterialVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaterialVo[]>(<any>null);
    }

    /**
     * 查询分页
     * @param current (optional) 当前页
     * @param keyWord (optional) 关键词
     * @param property (optional) 物料属性
     * @param size (optional) 每页的数量
     * @param typeId (optional) 物料类型Id
     * @return OK
     */
    getPageMaterial(current: number | null | undefined, keyWord: string | null | undefined, property: number | null | undefined, size: number | null | undefined, typeId: string | null | undefined): Promise<IPageOfMaterialVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        if (property !== undefined)
            url_ += "property=" + encodeURIComponent("" + property) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageMaterial(_response);
        });
    }

    protected processGetPageMaterial(response: AxiosResponse): Promise<IPageOfMaterialVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfMaterialVo.fromJS(resultData200) : new IPageOfMaterialVo();
            return result200;
        }
        return Promise.resolve<IPageOfMaterialVo>(<any>null);
    }

    /**
     * 同步产品物料
     * @param synchronousProductMaterialAddDTO synchronousProductMaterialAddDTO
     * @return OK
     */
    synchronousProductMaterial(synchronousProductMaterialAddDTO: SynchronousProductMaterialAddDTO): Promise<number> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/synchronous-product-material";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(synchronousProductMaterialAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSynchronousProductMaterial(_response);
        });
    }

    protected processSynchronousProductMaterial(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * 修改物料
     * @param materialUpdateDTO materialUpdateDTO
     * @return OK
     */
    updateMaterial(materialUpdateDTO: MaterialUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/material/update-material";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(materialUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateMaterial(_response);
        });
    }

    protected processUpdateMaterial(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class ServiceRouteServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    listRoutes(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListRoutes(_response);
        });
    }

    protected processListRoutes(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class ListRoutesServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    1(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    2(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process2(_response);
        });
    }

    protected process2(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    3(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process3(_response);
        });
    }

    protected process3(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    5(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process5(_response);
        });
    }

    protected process5(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    6(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process6(_response);
        });
    }

    protected process6(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    4(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-material')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process4(_response);
        });
    }

    protected process4(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class BomCraftVersionVO implements IBomCraftVersionVO {
    /** 主键id */
    id!: string | undefined;
    /** bom版本 */
    version!: string | undefined;

    constructor(data?: IBomCraftVersionVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): BomCraftVersionVO {
        data = typeof data === 'object' ? data : {};
        let result = new BomCraftVersionVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        return data; 
    }
}

export interface IBomCraftVersionVO {
    /** 主键id */
    id: string | undefined;
    /** bom版本 */
    version: string | undefined;
}

export class BomMaterialAddDTO implements IBomMaterialAddDTO {
    /** id */
    id!: string | undefined;
    /** 物料编码 */
    materialCode!: string;
    /** 物料Id */
    materialId!: string;
    /** 物料名称 */
    materialName!: string;
    /** 物料类型 */
    materialType!: string | undefined;
    /** 父级物料Id */
    parentId!: string;
    /** 父级标识 */
    parentLevel!: string;
    /** 关联的工序 */
    processAddDTOS!: BomProcessAddDTO[] | undefined;
    /** 物料属性 */
    property!: number;
    /** 备注 */
    remark!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 材质 */
    stuff!: string | undefined;
    /** 计量单位 */
    unit!: string | undefined;
    /** bom版本Id */
    versionId!: string;

    constructor(data?: IBomMaterialAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialType = data["materialType"];
            this.parentId = data["parentId"];
            this.parentLevel = data["parentLevel"];
            if (data["processAddDTOS"] && data["processAddDTOS"].constructor === Array) {
                this.processAddDTOS = [] as any;
                for (let item of data["processAddDTOS"])
                    this.processAddDTOS!.push(BomProcessAddDTO.fromJS(item));
            }
            this.property = data["property"];
            this.remark = data["remark"];
            this.standardModel = data["standardModel"];
            this.stuff = data["stuff"];
            this.unit = data["unit"];
            this.versionId = data["versionId"];
        }
    }

    static fromJS(data: any): BomMaterialAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BomMaterialAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialType"] = this.materialType;
        data["parentId"] = this.parentId;
        data["parentLevel"] = this.parentLevel;
        if (this.processAddDTOS && this.processAddDTOS.constructor === Array) {
            data["processAddDTOS"] = [];
            for (let item of this.processAddDTOS)
                data["processAddDTOS"].push(item.toJSON());
        }
        data["property"] = this.property;
        data["remark"] = this.remark;
        data["standardModel"] = this.standardModel;
        data["stuff"] = this.stuff;
        data["unit"] = this.unit;
        data["versionId"] = this.versionId;
        return data; 
    }
}

export interface IBomMaterialAddDTO {
    /** id */
    id: string | undefined;
    /** 物料编码 */
    materialCode: string;
    /** 物料Id */
    materialId: string;
    /** 物料名称 */
    materialName: string;
    /** 物料类型 */
    materialType: string | undefined;
    /** 父级物料Id */
    parentId: string;
    /** 父级标识 */
    parentLevel: string;
    /** 关联的工序 */
    processAddDTOS: BomProcessAddDTO[] | undefined;
    /** 物料属性 */
    property: number;
    /** 备注 */
    remark: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 材质 */
    stuff: string | undefined;
    /** 计量单位 */
    unit: string | undefined;
    /** bom版本Id */
    versionId: string;
}

export class BomMaterialAddPostDTO implements IBomMaterialAddPostDTO {
    /** id */
    id!: string | undefined;
    /** 物料Id */
    materialId!: string;
    /** 父级物料Id */
    parentId!: string;
    /** 关联的工序 */
    processAddDTOS!: BomProcessAddPostDTO[] | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** bom版本Id */
    versionId!: string;

    constructor(data?: IBomMaterialAddPostDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.materialId = data["materialId"];
            this.parentId = data["parentId"];
            if (data["processAddDTOS"] && data["processAddDTOS"].constructor === Array) {
                this.processAddDTOS = [] as any;
                for (let item of data["processAddDTOS"])
                    this.processAddDTOS!.push(BomProcessAddPostDTO.fromJS(item));
            }
            this.remark = data["remark"];
            this.versionId = data["versionId"];
        }
    }

    static fromJS(data: any): BomMaterialAddPostDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BomMaterialAddPostDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialId"] = this.materialId;
        data["parentId"] = this.parentId;
        if (this.processAddDTOS && this.processAddDTOS.constructor === Array) {
            data["processAddDTOS"] = [];
            for (let item of this.processAddDTOS)
                data["processAddDTOS"].push(item.toJSON());
        }
        data["remark"] = this.remark;
        data["versionId"] = this.versionId;
        return data; 
    }
}

export interface IBomMaterialAddPostDTO {
    /** id */
    id: string | undefined;
    /** 物料Id */
    materialId: string;
    /** 父级物料Id */
    parentId: string;
    /** 关联的工序 */
    processAddDTOS: BomProcessAddPostDTO[] | undefined;
    /** 备注 */
    remark: string | undefined;
    /** bom版本Id */
    versionId: string;
}

export class BomMaterialSimpleVO implements IBomMaterialSimpleVO {
    /** id */
    id!: string | undefined;
    /** 本级标识 */
    level!: string | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 父级物料Id */
    parentId!: string | undefined;

    constructor(data?: IBomMaterialSimpleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.level = data["level"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.parentId = data["parentId"];
        }
    }

    static fromJS(data: any): BomMaterialSimpleVO {
        data = typeof data === 'object' ? data : {};
        let result = new BomMaterialSimpleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["level"] = this.level;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["parentId"] = this.parentId;
        return data; 
    }
}

export interface IBomMaterialSimpleVO {
    /** id */
    id: string | undefined;
    /** 本级标识 */
    level: string | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 父级物料Id */
    parentId: string | undefined;
}

export class BomMaterialVO implements IBomMaterialVO {
    /** id */
    id!: string | undefined;
    /** 本级标识 */
    level!: string | undefined;
    /** 额定库存 */
    lowerLimit!: number | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料Id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 物料类型 */
    materialType!: string | undefined;
    /** 父级物料Id */
    parentId!: string | undefined;
    /** 父级标识 */
    parentLevel!: string | undefined;
    /** 关联的工序 */
    processVOList!: BomProcessVO[] | undefined;
    /** 物料属性 */
    property!: number | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 材质 */
    stuff!: string | undefined;
    /** 计量单位 */
    unit!: string | undefined;
    /** 安全库存 */
    upperLimit!: number | undefined;
    /** bom版本Id */
    versionId!: string | undefined;

    constructor(data?: IBomMaterialVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.level = data["level"];
            this.lowerLimit = data["lowerLimit"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialType = data["materialType"];
            this.parentId = data["parentId"];
            this.parentLevel = data["parentLevel"];
            if (data["processVOList"] && data["processVOList"].constructor === Array) {
                this.processVOList = [] as any;
                for (let item of data["processVOList"])
                    this.processVOList!.push(BomProcessVO.fromJS(item));
            }
            this.property = data["property"];
            this.remark = data["remark"];
            this.standardModel = data["standardModel"];
            this.stuff = data["stuff"];
            this.unit = data["unit"];
            this.upperLimit = data["upperLimit"];
            this.versionId = data["versionId"];
        }
    }

    static fromJS(data: any): BomMaterialVO {
        data = typeof data === 'object' ? data : {};
        let result = new BomMaterialVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["level"] = this.level;
        data["lowerLimit"] = this.lowerLimit;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialType"] = this.materialType;
        data["parentId"] = this.parentId;
        data["parentLevel"] = this.parentLevel;
        if (this.processVOList && this.processVOList.constructor === Array) {
            data["processVOList"] = [];
            for (let item of this.processVOList)
                data["processVOList"].push(item.toJSON());
        }
        data["property"] = this.property;
        data["remark"] = this.remark;
        data["standardModel"] = this.standardModel;
        data["stuff"] = this.stuff;
        data["unit"] = this.unit;
        data["upperLimit"] = this.upperLimit;
        data["versionId"] = this.versionId;
        return data; 
    }
}

export interface IBomMaterialVO {
    /** id */
    id: string | undefined;
    /** 本级标识 */
    level: string | undefined;
    /** 额定库存 */
    lowerLimit: number | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料Id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 物料类型 */
    materialType: string | undefined;
    /** 父级物料Id */
    parentId: string | undefined;
    /** 父级标识 */
    parentLevel: string | undefined;
    /** 关联的工序 */
    processVOList: BomProcessVO[] | undefined;
    /** 物料属性 */
    property: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 材质 */
    stuff: string | undefined;
    /** 计量单位 */
    unit: string | undefined;
    /** 安全库存 */
    upperLimit: number | undefined;
    /** bom版本Id */
    versionId: string | undefined;
}

export class BomProcessAddDTO implements IBomProcessAddDTO {
    /** 父级物料Id */
    bomMaterialId!: string;
    /** 用量分母 */
    denominator!: number | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 固定损耗 */
    loss!: number | undefined;
    /** 用量分子 */
    molecule!: number | undefined;
    /** 工序Code */
    processCode!: string;
    /** 工序Id */
    processId!: string;
    /** 工序名称 */
    processName!: string;

    constructor(data?: IBomProcessAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bomMaterialId = data["bomMaterialId"];
            this.denominator = data["denominator"];
            this.id = data["id"];
            this.loss = data["loss"];
            this.molecule = data["molecule"];
            this.processCode = data["processCode"];
            this.processId = data["processId"];
            this.processName = data["processName"];
        }
    }

    static fromJS(data: any): BomProcessAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BomProcessAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bomMaterialId"] = this.bomMaterialId;
        data["denominator"] = this.denominator;
        data["id"] = this.id;
        data["loss"] = this.loss;
        data["molecule"] = this.molecule;
        data["processCode"] = this.processCode;
        data["processId"] = this.processId;
        data["processName"] = this.processName;
        return data; 
    }
}

export interface IBomProcessAddDTO {
    /** 父级物料Id */
    bomMaterialId: string;
    /** 用量分母 */
    denominator: number | undefined;
    /** 主键id */
    id: string | undefined;
    /** 固定损耗 */
    loss: number | undefined;
    /** 用量分子 */
    molecule: number | undefined;
    /** 工序Code */
    processCode: string;
    /** 工序Id */
    processId: string;
    /** 工序名称 */
    processName: string;
}

export class BomProcessAddPostDTO implements IBomProcessAddPostDTO {
    /** 用量分母 */
    denominator!: number | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 固定损耗 */
    loss!: number | undefined;
    /** 用量分子 */
    molecule!: number | undefined;
    /** 工序Id */
    processId!: string;

    constructor(data?: IBomProcessAddPostDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.denominator = data["denominator"];
            this.id = data["id"];
            this.loss = data["loss"];
            this.molecule = data["molecule"];
            this.processId = data["processId"];
        }
    }

    static fromJS(data: any): BomProcessAddPostDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BomProcessAddPostDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["denominator"] = this.denominator;
        data["id"] = this.id;
        data["loss"] = this.loss;
        data["molecule"] = this.molecule;
        data["processId"] = this.processId;
        return data; 
    }
}

export interface IBomProcessAddPostDTO {
    /** 用量分母 */
    denominator: number | undefined;
    /** 主键id */
    id: string | undefined;
    /** 固定损耗 */
    loss: number | undefined;
    /** 用量分子 */
    molecule: number | undefined;
    /** 工序Id */
    processId: string;
}

export class BomProcessVO implements IBomProcessVO {
    /** 用量分母 */
    denominator!: number | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 固定损耗 */
    loss!: number | undefined;
    /** 用量分子 */
    molecule!: number | undefined;
    /** 工序Code */
    processCode!: string | undefined;
    /** processId */
    processId!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;

    constructor(data?: IBomProcessVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.denominator = data["denominator"];
            this.id = data["id"];
            this.loss = data["loss"];
            this.molecule = data["molecule"];
            this.processCode = data["processCode"];
            this.processId = data["processId"];
            this.processName = data["processName"];
        }
    }

    static fromJS(data: any): BomProcessVO {
        data = typeof data === 'object' ? data : {};
        let result = new BomProcessVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["denominator"] = this.denominator;
        data["id"] = this.id;
        data["loss"] = this.loss;
        data["molecule"] = this.molecule;
        data["processCode"] = this.processCode;
        data["processId"] = this.processId;
        data["processName"] = this.processName;
        return data; 
    }
}

export interface IBomProcessVO {
    /** 用量分母 */
    denominator: number | undefined;
    /** 主键id */
    id: string | undefined;
    /** 固定损耗 */
    loss: number | undefined;
    /** 用量分子 */
    molecule: number | undefined;
    /** 工序Code */
    processCode: string | undefined;
    /** processId */
    processId: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
}

export class BomVersionAddDTO implements IBomVersionAddDTO {
    /** 工艺版本Id */
    craftId!: string;
    /** 工艺版本 */
    craftVersion!: string;
    /** 所属产品 */
    productId!: string;

    constructor(data?: IBomVersionAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.craftId = data["craftId"];
            this.craftVersion = data["craftVersion"];
            this.productId = data["productId"];
        }
    }

    static fromJS(data: any): BomVersionAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BomVersionAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craftId"] = this.craftId;
        data["craftVersion"] = this.craftVersion;
        data["productId"] = this.productId;
        return data; 
    }
}

export interface IBomVersionAddDTO {
    /** 工艺版本Id */
    craftId: string;
    /** 工艺版本 */
    craftVersion: string;
    /** 所属产品 */
    productId: string;
}

export class BomVersionApiAddDTO implements IBomVersionApiAddDTO {
    /** 工艺版本Id */
    craftId!: string;
    /** 所属产品 */
    productId!: string;

    constructor(data?: IBomVersionApiAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.craftId = data["craftId"];
            this.productId = data["productId"];
        }
    }

    static fromJS(data: any): BomVersionApiAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BomVersionApiAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craftId"] = this.craftId;
        data["productId"] = this.productId;
        return data; 
    }
}

export interface IBomVersionApiAddDTO {
    /** 工艺版本Id */
    craftId: string;
    /** 所属产品 */
    productId: string;
}

export class BomVersionRemarkVO implements IBomVersionRemarkVO {
    /** 备注内容 */
    remark!: string | undefined;
    /** 版本号 */
    version!: string | undefined;

    constructor(data?: IBomVersionRemarkVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.remark = data["remark"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): BomVersionRemarkVO {
        data = typeof data === 'object' ? data : {};
        let result = new BomVersionRemarkVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remark"] = this.remark;
        data["version"] = this.version;
        return data; 
    }
}

export interface IBomVersionRemarkVO {
    /** 备注内容 */
    remark: string | undefined;
    /** 版本号 */
    version: string | undefined;
}

export class BomVersionVO implements IBomVersionVO {
    /** 工艺版本Id */
    craftId!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 所属产品 */
    productId!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** bom版本 */
    version!: string | undefined;
    /** 版本状态 0：未定版，1：已定版 */
    versionStatus!: number | undefined;

    constructor(data?: IBomVersionVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.craftId = data["craftId"];
            this.id = data["id"];
            this.productId = data["productId"];
            this.remark = data["remark"];
            this.version = data["version"];
            this.versionStatus = data["versionStatus"];
        }
    }

    static fromJS(data: any): BomVersionVO {
        data = typeof data === 'object' ? data : {};
        let result = new BomVersionVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craftId"] = this.craftId;
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["remark"] = this.remark;
        data["version"] = this.version;
        data["versionStatus"] = this.versionStatus;
        return data; 
    }
}

export interface IBomVersionVO {
    /** 工艺版本Id */
    craftId: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 所属产品 */
    productId: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** bom版本 */
    version: string | undefined;
    /** 版本状态 0：未定版，1：已定版 */
    versionStatus: number | undefined;
}

export class GatewayFilterDefinition implements IGatewayFilterDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayFilterDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayFilterDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayFilterDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayFilterDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GatewayPredicateDefinition implements IGatewayPredicateDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayPredicateDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayPredicateDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPredicateDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayPredicateDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class IPageOfMaterialTypeVo implements IIPageOfMaterialTypeVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: MaterialTypeVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfMaterialTypeVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(MaterialTypeVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfMaterialTypeVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfMaterialTypeVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfMaterialTypeVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: MaterialTypeVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfMaterialVo implements IIPageOfMaterialVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: MaterialVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfMaterialVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(MaterialVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfMaterialVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfMaterialVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfMaterialVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: MaterialVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class MaterialAddDTO implements IMaterialAddDTO {
    /** 物料条码 */
    barCode!: string | undefined;
    /** 物料编码 */
    code!: string;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 自定义字段1 */
    extend1!: string | undefined;
    /** 自定义字段2 */
    extend2!: string | undefined;
    /** 自定义字段3 */
    extend3!: string | undefined;
    /** 自定义字段4 */
    extend4!: string | undefined;
    /** 自定义字段5 */
    extend5!: string | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck!: number;
    /** 额定库存 */
    lowerLimit!: number | undefined;
    /** 物料名称 */
    name!: string;
    /** 物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它 */
    property!: number;
    /** 备注 */
    remark!: string | undefined;
    /** 规格 */
    standardModel!: string | undefined;
    /** 材质 */
    stuff!: string | undefined;
    /** 物料类型Id */
    typeId!: string;
    /** 物料类型名称 */
    typeName!: string | undefined;
    /** 计量单位 */
    unit!: string | undefined;
    /** 安全库存 */
    upperLimit!: number | undefined;

    constructor(data?: IMaterialAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.barCode = data["barCode"];
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.isMustCheck = data["isMustCheck"];
            this.lowerLimit = data["lowerLimit"];
            this.name = data["name"];
            this.property = data["property"];
            this.remark = data["remark"];
            this.standardModel = data["standardModel"];
            this.stuff = data["stuff"];
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.unit = data["unit"];
            this.upperLimit = data["upperLimit"];
        }
    }

    static fromJS(data: any): MaterialAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barCode"] = this.barCode;
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["isMustCheck"] = this.isMustCheck;
        data["lowerLimit"] = this.lowerLimit;
        data["name"] = this.name;
        data["property"] = this.property;
        data["remark"] = this.remark;
        data["standardModel"] = this.standardModel;
        data["stuff"] = this.stuff;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["unit"] = this.unit;
        data["upperLimit"] = this.upperLimit;
        return data; 
    }
}

export interface IMaterialAddDTO {
    /** 物料条码 */
    barCode: string | undefined;
    /** 物料编码 */
    code: string;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 自定义字段1 */
    extend1: string | undefined;
    /** 自定义字段2 */
    extend2: string | undefined;
    /** 自定义字段3 */
    extend3: string | undefined;
    /** 自定义字段4 */
    extend4: string | undefined;
    /** 自定义字段5 */
    extend5: string | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck: number;
    /** 额定库存 */
    lowerLimit: number | undefined;
    /** 物料名称 */
    name: string;
    /** 物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它 */
    property: number;
    /** 备注 */
    remark: string | undefined;
    /** 规格 */
    standardModel: string | undefined;
    /** 材质 */
    stuff: string | undefined;
    /** 物料类型Id */
    typeId: string;
    /** 物料类型名称 */
    typeName: string | undefined;
    /** 计量单位 */
    unit: string | undefined;
    /** 安全库存 */
    upperLimit: number | undefined;
}

export class MaterialExportDTO implements IMaterialExportDTO {
    /** 是否选中导出 */
    exportSelected!: boolean | undefined;
    /** 关键词 */
    keyWord!: string | undefined;
    /** 物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它 */
    property!: number | undefined;
    /** 选中记录id集合 */
    selectedRecords!: string[] | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 物料类型ID */
    typeId!: string | undefined;

    constructor(data?: IMaterialExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.exportSelected = data["exportSelected"];
            this.keyWord = data["keyWord"];
            this.property = data["property"];
            if (data["selectedRecords"] && data["selectedRecords"].constructor === Array) {
                this.selectedRecords = [] as any;
                for (let item of data["selectedRecords"])
                    this.selectedRecords!.push(item);
            }
            this.tenantId = data["tenantId"];
            this.typeId = data["typeId"];
        }
    }

    static fromJS(data: any): MaterialExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportSelected"] = this.exportSelected;
        data["keyWord"] = this.keyWord;
        data["property"] = this.property;
        if (this.selectedRecords && this.selectedRecords.constructor === Array) {
            data["selectedRecords"] = [];
            for (let item of this.selectedRecords)
                data["selectedRecords"].push(item);
        }
        data["tenantId"] = this.tenantId;
        data["typeId"] = this.typeId;
        return data; 
    }
}

export interface IMaterialExportDTO {
    /** 是否选中导出 */
    exportSelected: boolean | undefined;
    /** 关键词 */
    keyWord: string | undefined;
    /** 物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它 */
    property: number | undefined;
    /** 选中记录id集合 */
    selectedRecords: string[] | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 物料类型ID */
    typeId: string | undefined;
}

export class MaterialExportResult implements IMaterialExportResult {
    /** 失败记录数 */
    failUploadRecords!: number | undefined;
    /** 成功上传记录数 */
    successUploadRecords!: number | undefined;
    /** 上传记录数 */
    uploadTotal!: number | undefined;

    constructor(data?: IMaterialExportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.failUploadRecords = data["failUploadRecords"];
            this.successUploadRecords = data["successUploadRecords"];
            this.uploadTotal = data["uploadTotal"];
        }
    }

    static fromJS(data: any): MaterialExportResult {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialExportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["failUploadRecords"] = this.failUploadRecords;
        data["successUploadRecords"] = this.successUploadRecords;
        data["uploadTotal"] = this.uploadTotal;
        return data; 
    }
}

export interface IMaterialExportResult {
    /** 失败记录数 */
    failUploadRecords: number | undefined;
    /** 成功上传记录数 */
    successUploadRecords: number | undefined;
    /** 上传记录数 */
    uploadTotal: number | undefined;
}

export class MaterialFieldSettingDTO implements IMaterialFieldSettingDTO {
    /** 字段编号 */
    code!: string;
    /** id */
    id!: string | undefined;
    /** 是否显示  0-不显示(默认)；1-显示 */
    isDisplay!: number;
    /** 字段名称 */
    name!: string;

    constructor(data?: IMaterialFieldSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.isDisplay = data["isDisplay"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): MaterialFieldSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialFieldSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["isDisplay"] = this.isDisplay;
        data["name"] = this.name;
        return data; 
    }
}

export interface IMaterialFieldSettingDTO {
    /** 字段编号 */
    code: string;
    /** id */
    id: string | undefined;
    /** 是否显示  0-不显示(默认)；1-显示 */
    isDisplay: number;
    /** 字段名称 */
    name: string;
}

export class MaterialFieldSettingVO implements IMaterialFieldSettingVO {
    /** 字段编号 */
    code!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 是否显示  0-不显示(默认)；1-显示 */
    isDisplay!: number | undefined;
    /** 字段名称 */
    name!: string | undefined;

    constructor(data?: IMaterialFieldSettingVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.isDisplay = data["isDisplay"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): MaterialFieldSettingVO {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialFieldSettingVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["isDisplay"] = this.isDisplay;
        data["name"] = this.name;
        return data; 
    }
}

export interface IMaterialFieldSettingVO {
    /** 字段编号 */
    code: string | undefined;
    /** id */
    id: string | undefined;
    /** 是否显示  0-不显示(默认)；1-显示 */
    isDisplay: number | undefined;
    /** 字段名称 */
    name: string | undefined;
}

export class MaterialTypeAddDTO implements IMaterialTypeAddDTO {
    /** 物料类型编码 */
    code!: string;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 物料类型名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IMaterialTypeAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): MaterialTypeAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialTypeAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IMaterialTypeAddDTO {
    /** 物料类型编码 */
    code: string;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 物料类型名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

export class MaterialTypeUpdateDTO implements IMaterialTypeUpdateDTO {
    /** 物料类型编码 */
    code!: string;
    /** id */
    id!: string;
    /** 物料类型名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IMaterialTypeUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): MaterialTypeUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialTypeUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IMaterialTypeUpdateDTO {
    /** 物料类型编码 */
    code: string;
    /** id */
    id: string;
    /** 物料类型名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

export class MaterialTypeVo implements IMaterialTypeVo {
    /** 物料类型编码 */
    code!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 物料类型名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IMaterialTypeVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): MaterialTypeVo {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialTypeVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IMaterialTypeVo {
    /** 物料类型编码 */
    code: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 物料类型名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class MaterialUpdateDTO implements IMaterialUpdateDTO {
    /** 物料条码 */
    barCode!: string;
    /** 物料编码 */
    code!: string;
    /** 自定义字段1 */
    extend1!: string | undefined;
    /** 自定义字段2 */
    extend2!: string | undefined;
    /** 自定义字段3 */
    extend3!: string | undefined;
    /** 自定义字段4 */
    extend4!: string | undefined;
    /** 自定义字段5 */
    extend5!: string | undefined;
    /** id */
    id!: string;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck!: number;
    /** 额定库存 */
    lowerLimit!: number | undefined;
    /** 物料名称 */
    name!: string;
    /** 物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它 */
    property!: number;
    /** 备注 */
    remark!: string | undefined;
    /** 规格 */
    standardModel!: string | undefined;
    /** 材质 */
    stuff!: string | undefined;
    /** 物料类型Id */
    typeId!: string;
    /** 物料类型名称 */
    typeName!: string | undefined;
    /** 计量单位 */
    unit!: string | undefined;
    /** 安全库存 */
    upperLimit!: number | undefined;

    constructor(data?: IMaterialUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.barCode = data["barCode"];
            this.code = data["code"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.isMustCheck = data["isMustCheck"];
            this.lowerLimit = data["lowerLimit"];
            this.name = data["name"];
            this.property = data["property"];
            this.remark = data["remark"];
            this.standardModel = data["standardModel"];
            this.stuff = data["stuff"];
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.unit = data["unit"];
            this.upperLimit = data["upperLimit"];
        }
    }

    static fromJS(data: any): MaterialUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barCode"] = this.barCode;
        data["code"] = this.code;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["isMustCheck"] = this.isMustCheck;
        data["lowerLimit"] = this.lowerLimit;
        data["name"] = this.name;
        data["property"] = this.property;
        data["remark"] = this.remark;
        data["standardModel"] = this.standardModel;
        data["stuff"] = this.stuff;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["unit"] = this.unit;
        data["upperLimit"] = this.upperLimit;
        return data; 
    }
}

export interface IMaterialUpdateDTO {
    /** 物料条码 */
    barCode: string;
    /** 物料编码 */
    code: string;
    /** 自定义字段1 */
    extend1: string | undefined;
    /** 自定义字段2 */
    extend2: string | undefined;
    /** 自定义字段3 */
    extend3: string | undefined;
    /** 自定义字段4 */
    extend4: string | undefined;
    /** 自定义字段5 */
    extend5: string | undefined;
    /** id */
    id: string;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck: number;
    /** 额定库存 */
    lowerLimit: number | undefined;
    /** 物料名称 */
    name: string;
    /** 物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它 */
    property: number;
    /** 备注 */
    remark: string | undefined;
    /** 规格 */
    standardModel: string | undefined;
    /** 材质 */
    stuff: string | undefined;
    /** 物料类型Id */
    typeId: string;
    /** 物料类型名称 */
    typeName: string | undefined;
    /** 计量单位 */
    unit: string | undefined;
    /** 安全库存 */
    upperLimit: number | undefined;
}

export class MaterialVo implements IMaterialVo {
    /** 所属库位Id */
    areaId!: string | undefined;
    /** 所属库区名称 */
    areaName!: string | undefined;
    /** 物料条码 */
    barCode!: string | undefined;
    /** 物料编码 */
    code!: string | undefined;
    /** 显示编码 */
    displayCode!: string | undefined;
    /** 自定义字段1 */
    extend1!: string | undefined;
    /** 自定义字段2 */
    extend2!: string | undefined;
    /** 自定义字段3 */
    extend3!: string | undefined;
    /** 自定义字段4 */
    extend4!: string | undefined;
    /** 自定义字段5 */
    extend5!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck!: number | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheckName!: string | undefined;
    /** 所属库位Id */
    locationId!: string | undefined;
    /** 所属库区名称 */
    locationName!: string | undefined;
    /** 额定库存 */
    lowerLimit!: number | undefined;
    /** 物料名称 */
    name!: string | undefined;
    /** 物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它 */
    property!: number | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 退库数量 */
    returnNum!: number | undefined;
    /** 规格 */
    standardModel!: string | undefined;
    /** 出库数量 */
    stockOutNum!: number | undefined;
    /** 材质 */
    stuff!: string | undefined;
    /** 物料类型Id */
    typeId!: string | undefined;
    /** 物料类型名称 */
    typeName!: string | undefined;
    /** 计量单位 */
    unit!: string | undefined;
    /** 安全库存 */
    upperLimit!: number | undefined;

    constructor(data?: IMaterialVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.barCode = data["barCode"];
            this.code = data["code"];
            this.displayCode = data["displayCode"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.isMustCheck = data["isMustCheck"];
            this.isMustCheckName = data["isMustCheckName"];
            this.locationId = data["locationId"];
            this.locationName = data["locationName"];
            this.lowerLimit = data["lowerLimit"];
            this.name = data["name"];
            this.property = data["property"];
            this.remark = data["remark"];
            this.returnNum = data["returnNum"];
            this.standardModel = data["standardModel"];
            this.stockOutNum = data["stockOutNum"];
            this.stuff = data["stuff"];
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.unit = data["unit"];
            this.upperLimit = data["upperLimit"];
        }
    }

    static fromJS(data: any): MaterialVo {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["barCode"] = this.barCode;
        data["code"] = this.code;
        data["displayCode"] = this.displayCode;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["isMustCheck"] = this.isMustCheck;
        data["isMustCheckName"] = this.isMustCheckName;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["lowerLimit"] = this.lowerLimit;
        data["name"] = this.name;
        data["property"] = this.property;
        data["remark"] = this.remark;
        data["returnNum"] = this.returnNum;
        data["standardModel"] = this.standardModel;
        data["stockOutNum"] = this.stockOutNum;
        data["stuff"] = this.stuff;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["unit"] = this.unit;
        data["upperLimit"] = this.upperLimit;
        return data; 
    }
}

export interface IMaterialVo {
    /** 所属库位Id */
    areaId: string | undefined;
    /** 所属库区名称 */
    areaName: string | undefined;
    /** 物料条码 */
    barCode: string | undefined;
    /** 物料编码 */
    code: string | undefined;
    /** 显示编码 */
    displayCode: string | undefined;
    /** 自定义字段1 */
    extend1: string | undefined;
    /** 自定义字段2 */
    extend2: string | undefined;
    /** 自定义字段3 */
    extend3: string | undefined;
    /** 自定义字段4 */
    extend4: string | undefined;
    /** 自定义字段5 */
    extend5: string | undefined;
    /** id */
    id: string | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck: number | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheckName: string | undefined;
    /** 所属库位Id */
    locationId: string | undefined;
    /** 所属库区名称 */
    locationName: string | undefined;
    /** 额定库存 */
    lowerLimit: number | undefined;
    /** 物料名称 */
    name: string | undefined;
    /** 物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它 */
    property: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 退库数量 */
    returnNum: number | undefined;
    /** 规格 */
    standardModel: string | undefined;
    /** 出库数量 */
    stockOutNum: number | undefined;
    /** 材质 */
    stuff: string | undefined;
    /** 物料类型Id */
    typeId: string | undefined;
    /** 物料类型名称 */
    typeName: string | undefined;
    /** 计量单位 */
    unit: string | undefined;
    /** 安全库存 */
    upperLimit: number | undefined;
}

export class ProductAddDTO implements IProductAddDTO {
    /** 附件 */
    attachment!: string | undefined;
    /** 产品编码 */
    code!: string;
    /** 刀具编号 */
    cutterCode!: string | undefined;
    /** 产品描述 */
    description!: string | undefined;
    /** 扩展字段1 */
    extend1!: string | undefined;
    /** 扩展字段2 */
    extend2!: string | undefined;
    /** 扩展字段3 */
    extend3!: string | undefined;
    /** 扩展字段4 */
    extend4!: string | undefined;
    /** 扩展字段5 */
    extend5!: string | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 夹具编号 */
    moldCode!: string | undefined;
    /** 产品名称 */
    name!: string;
    /** 替代物料编号 */
    replaceCodes!: string | undefined;
    /** 替代材料供应商 */
    replaceSupplier!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 材料材质 */
    stuff!: string | undefined;
    /** 材料状态 */
    stuffStatus!: string | undefined;
    /** 原材料供应商 */
    supplier!: string | undefined;
    /** 所属产品类型 */
    typeId!: string;
    /** 计量单位 */
    unit!: string | undefined;

    constructor(data?: IProductAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attachment = data["attachment"];
            this.code = data["code"];
            this.cutterCode = data["cutterCode"];
            this.description = data["description"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.materialCode = data["materialCode"];
            this.moldCode = data["moldCode"];
            this.name = data["name"];
            this.replaceCodes = data["replaceCodes"];
            this.replaceSupplier = data["replaceSupplier"];
            this.standardModel = data["standardModel"];
            this.stuff = data["stuff"];
            this.stuffStatus = data["stuffStatus"];
            this.supplier = data["supplier"];
            this.typeId = data["typeId"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): ProductAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachment"] = this.attachment;
        data["code"] = this.code;
        data["cutterCode"] = this.cutterCode;
        data["description"] = this.description;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["materialCode"] = this.materialCode;
        data["moldCode"] = this.moldCode;
        data["name"] = this.name;
        data["replaceCodes"] = this.replaceCodes;
        data["replaceSupplier"] = this.replaceSupplier;
        data["standardModel"] = this.standardModel;
        data["stuff"] = this.stuff;
        data["stuffStatus"] = this.stuffStatus;
        data["supplier"] = this.supplier;
        data["typeId"] = this.typeId;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IProductAddDTO {
    /** 附件 */
    attachment: string | undefined;
    /** 产品编码 */
    code: string;
    /** 刀具编号 */
    cutterCode: string | undefined;
    /** 产品描述 */
    description: string | undefined;
    /** 扩展字段1 */
    extend1: string | undefined;
    /** 扩展字段2 */
    extend2: string | undefined;
    /** 扩展字段3 */
    extend3: string | undefined;
    /** 扩展字段4 */
    extend4: string | undefined;
    /** 扩展字段5 */
    extend5: string | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 夹具编号 */
    moldCode: string | undefined;
    /** 产品名称 */
    name: string;
    /** 替代物料编号 */
    replaceCodes: string | undefined;
    /** 替代材料供应商 */
    replaceSupplier: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 材料材质 */
    stuff: string | undefined;
    /** 材料状态 */
    stuffStatus: string | undefined;
    /** 原材料供应商 */
    supplier: string | undefined;
    /** 所属产品类型 */
    typeId: string;
    /** 计量单位 */
    unit: string | undefined;
}

export class RouteDefinition implements IRouteDefinition {
    compatibleMode!: number | undefined;
    filters!: GatewayFilterDefinition[] | undefined;
    id!: string | undefined;
    ignoreValidate!: number | undefined;
    mergeResult!: number | undefined;
    name!: string | undefined;
    needToken!: number | undefined;
    order!: number | undefined;
    path!: string | undefined;
    permission!: number | undefined;
    predicates!: GatewayPredicateDefinition[] | undefined;
    status!: number | undefined;
    uri!: string | undefined;
    version!: string | undefined;

    constructor(data?: IRouteDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.compatibleMode = data["compatibleMode"];
            if (data["filters"] && data["filters"].constructor === Array) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(GatewayFilterDefinition.fromJS(item));
            }
            this.id = data["id"];
            this.ignoreValidate = data["ignoreValidate"];
            this.mergeResult = data["mergeResult"];
            this.name = data["name"];
            this.needToken = data["needToken"];
            this.order = data["order"];
            this.path = data["path"];
            this.permission = data["permission"];
            if (data["predicates"] && data["predicates"].constructor === Array) {
                this.predicates = [] as any;
                for (let item of data["predicates"])
                    this.predicates!.push(GatewayPredicateDefinition.fromJS(item));
            }
            this.status = data["status"];
            this.uri = data["uri"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): RouteDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compatibleMode"] = this.compatibleMode;
        if (this.filters && this.filters.constructor === Array) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["ignoreValidate"] = this.ignoreValidate;
        data["mergeResult"] = this.mergeResult;
        data["name"] = this.name;
        data["needToken"] = this.needToken;
        data["order"] = this.order;
        data["path"] = this.path;
        data["permission"] = this.permission;
        if (this.predicates && this.predicates.constructor === Array) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["uri"] = this.uri;
        data["version"] = this.version;
        return data; 
    }
}

export interface IRouteDefinition {
    compatibleMode: number | undefined;
    filters: GatewayFilterDefinition[] | undefined;
    id: string | undefined;
    ignoreValidate: number | undefined;
    mergeResult: number | undefined;
    name: string | undefined;
    needToken: number | undefined;
    order: number | undefined;
    path: string | undefined;
    permission: number | undefined;
    predicates: GatewayPredicateDefinition[] | undefined;
    status: number | undefined;
    uri: string | undefined;
    version: string | undefined;
}

export class SaveRemarkDTO implements ISaveRemarkDTO {
    /** 备注 */
    remark!: string | undefined;
    /** bom版本Id */
    versionId!: string;

    constructor(data?: ISaveRemarkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.remark = data["remark"];
            this.versionId = data["versionId"];
        }
    }

    static fromJS(data: any): SaveRemarkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRemarkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remark"] = this.remark;
        data["versionId"] = this.versionId;
        return data; 
    }
}

export interface ISaveRemarkDTO {
    /** 备注 */
    remark: string | undefined;
    /** bom版本Id */
    versionId: string;
}

export class ServiceRouteInfo implements IServiceRouteInfo {
    createTime!: Date | undefined;
    description!: string | undefined;
    routeDefinitionList!: RouteDefinition[] | undefined;
    serviceId!: string | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IServiceRouteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.description = data["description"];
            if (data["routeDefinitionList"] && data["routeDefinitionList"].constructor === Array) {
                this.routeDefinitionList = [] as any;
                for (let item of data["routeDefinitionList"])
                    this.routeDefinitionList!.push(RouteDefinition.fromJS(item));
            }
            this.serviceId = data["serviceId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRouteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRouteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (this.routeDefinitionList && this.routeDefinitionList.constructor === Array) {
            data["routeDefinitionList"] = [];
            for (let item of this.routeDefinitionList)
                data["routeDefinitionList"].push(item.toJSON());
        }
        data["serviceId"] = this.serviceId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IServiceRouteInfo {
    createTime: Date | undefined;
    description: string | undefined;
    routeDefinitionList: RouteDefinition[] | undefined;
    serviceId: string | undefined;
    updateTime: Date | undefined;
}

export class SynchronousProductMaterialAddDTO implements ISynchronousProductMaterialAddDTO {
    /** 是否强制删除 */
    isDetele!: number | undefined;
    /** 产品编码名称集合 */
    productList!: ProductAddDTO[] | undefined;
    /** 物料类型Id */
    typeId!: string;

    constructor(data?: ISynchronousProductMaterialAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDetele = data["isDetele"];
            if (data["productList"] && data["productList"].constructor === Array) {
                this.productList = [] as any;
                for (let item of data["productList"])
                    this.productList!.push(ProductAddDTO.fromJS(item));
            }
            this.typeId = data["typeId"];
        }
    }

    static fromJS(data: any): SynchronousProductMaterialAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SynchronousProductMaterialAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDetele"] = this.isDetele;
        if (this.productList && this.productList.constructor === Array) {
            data["productList"] = [];
            for (let item of this.productList)
                data["productList"].push(item.toJSON());
        }
        data["typeId"] = this.typeId;
        return data; 
    }
}

export interface ISynchronousProductMaterialAddDTO {
    /** 是否强制删除 */
    isDetele: number | undefined;
    /** 产品编码名称集合 */
    productList: ProductAddDTO[] | undefined;
    /** 物料类型Id */
    typeId: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}